/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { ContactDeliveryMethod, QuotationBase } from '@gh/builder-shared-data';
import { createDialogRoute, FormState, FormStateBuilder } from '@gh/common-shared';
import { DialogInput } from '@gh/core-ui';

import { QuotePrintFilter } from '../../resources/quote.model';

export interface RfqQuoteFilterDialogConfig {
  base: QuotationBase;
  deliveryBy: ContactDeliveryMethod;
}

@Component({
  selector: 'gh-rfq-quote-filter-dialog',
  template: require('./rfq-quote-filter-dialog.component.html'),
  styles: [require('./rfq-quote-filter-dialog.component.scss')],
})
export class RfqQuoteFilterDialogComponent implements OnInit, DialogInput<RfqQuoteFilterDialogConfig> {
  input: RfqQuoteFilterDialogConfig;
  form: FormState<QuotePrintFilter>;

  constructor(private dialogRef: MatDialogRef<any>,
              private formStateBuilder: FormStateBuilder) {

  }

  get baseLabel(): string {
    return {
      [QuotationBase.QuickQuote]: 'lbl_base_quick_quote',
      [QuotationBase.SalesEstimate]: 'lbl_base_sales_estimate',
      [QuotationBase.HouseEstimate]: 'lbl_house_estimate',
    }[this.input.base];
  }

  ngOnInit(): void {
    this.form = this.formStateBuilder.buildPlain({
      value: {
        isAuthorityToProceedRequired: false,
        isPrintTakeOff: false,
        isShowBasePrice: false,
        isForEstimator: false,
        deliveryBy: this.input.deliveryBy,
      },
      children: {
        isAuthorityToProceedRequired: void 0,
        isPrintTakeOff: void 0,
        isShowBasePrice: void 0,
        isForEstimator: void 0,
        deliveryBy: void 0,
      },
    });
  }

  onApply(): void {
    this.dialogRef.close(this.form.submitValue);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}

export const rfqQuoteFilterDialogRoute = createDialogRoute({
  component: RfqQuoteFilterDialogComponent,
});
